export default {
    //正式機
    path:"https://ws.anuefund.com",
    CMSpath:"https://www.anuefund.com/cmsapi",
    domainPath: "https://www.anuefund.com",

    //W1
    // path:"https://ws.anuefund.com",
    // CMSpath:"https://w1.anuefund.com/cmsapi",
    // domainPath: "https://www.anuefund.com",
    
    //第二正式區
    //path:"https://wst.anuefund.com",
    //domainPath: "https://w1.anuefund.com",
    //第三正式區(新達)
    //path:"http://192.168.60.88",
    //domainPath:"http://192.168.60.61",
    //UAT60
    //path:"http://192.168.60.88",
    //CMSpath:"http://192.168.60.61/cmsapi",
    //domainPath: "../..",
    //UAT
    //path: "http://192.168.6.89",
    //domainPath: "../..",
    //Local(cross site 有問題)
    //path: "https://localhost:44362",
    //domainPath: "http://localhost:59306",
    //試算設定
    trialSetting: {
        trialYearMax: 40,
        trialYearMin: 1,
        trialYearDefalut: 20,
        budgetMax:150000,
        budgetMin:10000,
        budgetStep:10000,
        budgetDefault:40000,
        useYearMax:40,
        useYearMin:1,
        useYearDefault:20,
        altAmountMax:2000000,
        altAmountMin:10000,
        altAmountDefault:500000,
        altAmountStep:10000,
        drspAmountMax:100000,
        drspAmountMin:5000,
        drspAmountDefault:20000,
        drspAmountStep:5000,
    },
    //千分位
    format_with_substring(number) {
        let arr = (number + '').split('.');
        let int = arr[0] + '';
        let fraction = arr[1] || '';
        let f = int.length % 3;
        let r = int.substring(0, f);

        for (let i = 0; i < Math.floor(int.length / 3); i++) {
            r += ',' + int.substring(f + i * 3, f + (i + 1) * 3)
        }

        if (f === 0) {
            r = r.substring(1);
        }
        return r + (!!fraction ? "." + fraction : '');
    },
    //單筆申購 最低申購及級距文字
    minStepALTFormat(acctType){
        if(acctType === "acctT"){
            return "最低申購10,000元，增額級距1,000元";
        } else {
            return "最低申購400元，增額級距50元";
        }
    },
    //單筆申購 最低申購及級距文字
    minStepRSPFormat(acctType){
        if(acctType === "acctT"){
            return "最低申購5,000元，增額級距5,000元";
        } else {
            return "最低申購250元，增額級距250元";
        }
    }
}